import * as React from "react";

import { HintPos, TextOverflowHint } from "../TextOverflowHint/TextOverflowHint";

import { Container, Ext, Name, Root } from "./TextOverflow.styles";

interface TextOverflowProps {
    text: string;
    endedChars?: number;
    hintMaxWidth?: number;
    width?: string | number;
    minHeight?: string;
    pos?: HintPos;
}

export function TextOverflow(props: TextOverflowProps): JSX.Element {
    const width = props.width ?? 100;
    const endedChars = props.endedChars ?? 0;
    const visibleCharsPosition = props.text.length > endedChars ? props.text.length - endedChars : 0;

    return (
        <Root width={width} minHeight={props.minHeight}>
            <TextOverflowHint text={props.text} width={width} hintMaxWidth={props.hintMaxWidth} pos={props.pos}>
                <Container>
                    <Name>{props.text.substr(0, visibleCharsPosition)}</Name>
                    <Ext>{props.text.substr(visibleCharsPosition)}</Ext>
                </Container>
            </TextOverflowHint>
        </Root>
    );
}
